module.exports = __webpack_public_path__ + "view/img/caida.53eadb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/caida.jpg
// module id = PmI2
// module chunks = 11